<template>
    <div class="kplers">
        <v-select v-model="place"
                  taggable
                  :options="options"
                  label="address"
                  @search="onSearch"
                  placeholder="Tìm kiếm và chọn điểm đón"
        >
            <template slot="no-options">
                Gõ để tìm kiếm điểm đón...
            </template>
        </v-select>
    </div>

</template>

<script>
    import {RepositoryFactory} from "../services";
    import {MixinHelper} from "../services";
    import debounce from "lodash/debounce"

    const repo = RepositoryFactory.get('regions');
    export default {
        name: "SelectorPlace",
        mixins: [MixinHelper],
        props: {
            value: {
                type: String,
            }
        },
        created() {
            this.listSuggestPlace('');
        },
        data() {
            return {
                options: [],
            }
        },
        methods: {
            onSearch: debounce(function (search) {
                this.listSuggestPlace(search);
            }, 10),
            listSuggestPlace(search) {
                repo.listSuggestPlace(search)
                    .then(resp => {
                        this.options = this.getProp(resp, 'data.datas', []).map(item => {
                            let option = {};
                            option = {
                                ...option,
                                distance_library_id: this.getProp(item, 'id', 0),
                                address: this.getProp(item, 'street._name', '')
                            };
                            return option;
                        });
                    })
                    .catch(err => {
                        console.log(err);
                    })
            }
        },
        computed: {
            place: {
                get() {
                    return this.value;
                },
                set(val) {
                    if (typeof val === 'string') {
                        val = {...{}, address: val};
                    }
                    this.$emit('input', val);
                }
            }
        }
    }
</script>

<style>
    .kplers .v-select {
        border-radius: 4px;
        border: 1px solid #ccc;
    }

    .kplers div {
        left: 20px;
    }

    .kplers input.vs__search {
        padding-left: 15px;
        height: 38px;
        font-size: 14px;
    }

    .kplers .vs__selected {
        padding-left: 15px;
        font-size: 14px;
    }
</style>
